import { defineComponent } from "vue";

import "./loading.less";

export default defineComponent({
  props: {
    size: { type: Number, default: 32 },
  },
  setup(props) {
    return () => (
      <div class="feiyu-web-loading" style={{ fontSize: `${props.size}px` }}>
        <span class="feiyu-web-loading--spinner">
          {Array.from({ length: 12 }, (_, index) => {
            const style = {
              animationDelay: `${index / 12}s`,
              transform: `rotate(${30 * (index - 5)}deg) translateY(-150%)`,
            };
            return <i class="feiyu-web-loading--spinner-item" key={index} style={style} />;
          })}
        </span>
      </div>
    );
  },
});
